import axios from "axios";
import io from "socket.io-client";

// API配置
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// Socket.io配置
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";

// 🚀 订单提交API - 精准发射到后端
export const submitOrder = async (orderData) => {
  try {
    // 确保数据格式符合后端期望
    const formattedData = {
      items: orderData.items || [], // 购物车商品数组
      total_amount: parseFloat(orderData.total_amount) || 0, // 订单总金额
      pay_method: orderData.pay_method || 'CASH', // 支付方式
      user_id: orderData.user_id || null // 用户ID（可选）
    };
    
    console.log('🚀 发射订单数据到后端:', formattedData);
    
    const response = await axios.post(`${API_BASE_URL}/orders`, formattedData);
    
    console.log('✅ 后端响应:', response.data);
    return response.data;
  } catch (error) { 
    console.error('❌ 订单提交失败:', error.response?.data || error.message);
    throw error; 
  }
};

// 🚀 获取订单状态API
export const fetchOrderStatus = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/orders`);
    return res.data;
  } catch (error) {
    console.log("获取订单状态失败");
    throw error;
  }
};

// 🚀 清空所有订单记录API
export const clearAllOrders = async () => {
  try {
    await axios.delete(`${API_BASE_URL}/orders/debug/clear-all`);
    return true;
  } catch (error) {
    console.log("清理订单失败");
    throw error;
  }
};

// 🚀 创建Socket连接
export const createSocketConnection = () => {
  return io(SOCKET_URL);
};

// 🚀 健康检查API
export const healthCheck = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL.replace('/api', '')}/api/health`);
    return response.data;
  } catch (error) {
    console.log("健康检查失败");
    throw error;
  }
};

// 🚀 获取产品数据API
export const fetchProducts = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/products`);
    return response.data;
  } catch (error) {
    console.log("获取产品数据失败");
    throw error;
  }
};

// 📦 获取用户背包API
export const fetchInventory = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/inventory/${userId}`);
    console.log('📦 背包数据获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取背包数据失败:", error);
    throw error;
  }
};

// 🎁 兑换物品API
export const redeemItem = async (itemId, userId) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/inventory/${itemId}/redeem`, {
      userId: userId
    });
    console.log('🎁 物品兑换成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 物品兑换失败:", error);
    throw error;
  }
};

// 🏪 获取集市摊位状态API
export const getMarketStalls = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/market/stalls`);
    console.log('🏪 集市摊位数据获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取集市摊位失败:", error);
    throw error;
  }
};

// 📤 上架物品到摊位API
export const listItemToStall = async (sellerId, inventoryItemId, stallNumber, price) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/market/list`, {
      sellerId,
      inventoryItemId,
      stallNumber,
      price
    });
    console.log('📤 物品上架成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 物品上架失败:", error);
    throw error;
  }
};

// 💰 购买摊位物品API
export const buyFromStall = async (buyerId, listingId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/market/buy/${listingId}`, {
      buyerId
    });
    console.log('💰 购买成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 购买失败:", error);
    throw error;
  }
};

// 🗑️ 下架物品API
export const delistItem = async (sellerId, listingId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/market/list/${listingId}`, {
      data: { sellerId }
    });
    console.log('🗑️ 物品下架成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 物品下架失败:", error);
    throw error;
  }
};

// 👤 用户注册API
export const registerUser = async (userData, inviteCode = null) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/users/register`, {
      ...userData,
      inviteCode
    });
    console.log('👤 用户注册成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 用户注册失败:", error);
    throw error;
  }
};

// 📊 获取邀请统计API
export const getReferralStats = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/referral-stats`);
    console.log('📊 邀请统计获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取邀请统计失败:", error);
    throw error;
  }
};

// 💰 获取积分流水API
export const getPointLogs = async (userId, limit = 50) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/point-logs?limit=${limit}`);
    console.log('💰 积分流流水获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取积分流水失败:", error);
    throw error;
  }
};

// 🔍 验证邀请码API
export const validateInviteCode = async (inviteCode) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/users/validate-invite`, {
      inviteCode
    });
    console.log('🔍 邀请码验证成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 邀请码验证失败:", error);
    throw error;
  }
};

// 📸 每日打卡API
export const dailyPhotoCheckIn = async (userId, imageUrl = null) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/community/checkin`, {
      userId,
      imageUrl
    });
    console.log('📸 每日打卡成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 每日打卡失败:", error);
    throw error;
  }
};

// 🎰 游戏厅抽奖API
export const spinArcade = async (userId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/community/spin`, {
      userId
    });
    console.log('🎰 游戏厅抽奖成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 游戏厅抽奖失败:", error);
    throw error;
  }
};

// 📸 获取打卡墙API
export const getPhotoWall = async (limit = 50) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/community/photo-wall?limit=${limit}`);
    console.log('📸 打卡墙数据获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取打卡墙失败:", error);
    throw error;
  }
};

// 🎮 获取游戏统计API
export const getArcadeStats = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/community/arcade-stats/${userId}`);
    console.log('🎮 游戏统计获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取游戏统计失败:", error);
    throw error;
  }
};

// 🎁 碎片兑换神券API
export const exchangeFragmentsForVoucher = async (userId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/community/exchange-fragments`, {
      userId
    });
    console.log('🎁 碎片兑换成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 碎片兑换失败:", error);
    throw error;
  }
};

// 👕 装备物品API
export const equipItem = async (userId, itemType, itemId) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/users/${userId}/equip`, {
      itemType,
      itemId
    });
    console.log('👕 装备物品成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 装备物品失败:", error);
    throw error;
  }
};

// 🏬 实物核销API
export const redeemPhysicalItem = async (userId, itemId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/users/${userId}/redeem`, {
      itemId
    });
    console.log('🏬 实物核销成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 实物核销失败:", error);
    throw error;
  }
};

// 🖼️ 获取已兑换画廊API
export const getRedeemedGallery = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/gallery`);
    console.log('🖼️ 已兑换画廊获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取已兑换画廊失败:", error);
    throw error;
  }
};

// 🎯 获取用户完整档案API
export const getUserProfile = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/profile`);
    console.log('🎯 用户档案获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 获取用户档案失败:", error);
    throw error;
  }
};

// 👑 总统大屏API
export const getAdminDashboard = async (adminSecret) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/dashboard`, {
      headers: {
        'X-Admin-Secret': adminSecret
      }
    });
    console.log('👑 总统大屏数据获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 总统大屏数据获取失败:", error);
    throw error;
  }
};

// 📢 全服播报API
export const sendAdminBroadcast = async (adminSecret, message, type = 'INFO') => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/broadcast`, {
      message,
      type
    }, {
      headers: {
        'X-Admin-Secret': adminSecret
      }
    });
    console.log('📢 全服播报发送成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 全服播报发送失败:", error);
    throw error;
  }
};

// 🔍 管理员用户数据API
export const getAdminUsers = async (adminSecret, page = 1, limit = 50, search = '') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/users`, {
      params: { page, limit, search },
      headers: {
        'X-Admin-Secret': adminSecret
      }
    });
    console.log('🔍 管理员用户数据获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 管理员用户数据获取失败:", error);
    throw error;
  }
};

// 💰 管理员订单数据API
export const getAdminOrders = async (adminSecret, page = 1, limit = 50, status = '') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/orders`, {
      params: { page, limit, status },
      headers: {
        'X-Admin-Secret': adminSecret
      }
    });
    console.log('💰 管理员订单数据获取成功:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 管理员订单数据获取失败:", error);
    throw error;
  }
};

// 导出配置
export { API_BASE_URL, SOCKET_URL };
